import React, { useState } from 'react';
import styled from 'styled-components';

interface CourseFilterProps {
  onFilterChange: (category: string, searchTerm?: string) => void;
}

const SearchContainer = styled.div`
  max-width: 600px;
  margin: 0 auto 40px;
  position: relative;
  width: 100%;
  padding: 0 20px;
  box-sizing: border-box;
`;

const SearchInput = styled.input`
  width: 100%;
  padding: 15px 20px;
  padding-left: 50px;
  border-radius: 30px;
  background-color: rgba(255, 255, 255, 0.1);
  border: 2px solid rgba(255, 255, 255, 0.2);
  color: white;
  font-size: 1rem;
  transition: all 0.3s ease;
  box-sizing: border-box;
  
  &::placeholder {
    color: rgba(255, 255, 255, 0.5);
  }
  
  &:focus {
    outline: none;
    border-color: #00E5FF;
    box-shadow: 0 0 15px rgba(0, 229, 255, 0.3);
  }
  
  @media (max-width: 768px) {
    padding: 12px 20px;
    padding-left: 45px;
    font-size: 0.9rem;
  }
`;

const SearchIcon = styled.div`
  position: absolute;
  left: 35px;
  top: 50%;
  transform: translateY(-50%);
  color: rgba(255, 255, 255, 0.5);
  
  @media (max-width: 768px) {
    left: 30px;
  }
`;

const CourseFilter: React.FC<CourseFilterProps> = ({ onFilterChange }) => {
  const [searchTerm, setSearchTerm] = useState('');
  
  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newSearchTerm = e.target.value;
    setSearchTerm(newSearchTerm);
    onFilterChange('todos', newSearchTerm);
  };
  
  return (
    <SearchContainer>
      <SearchIcon>
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="11" cy="11" r="8"></circle>
          <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
        </svg>
      </SearchIcon>
      <SearchInput 
        type="text" 
        placeholder="Buscar curso..." 
        value={searchTerm}
        onChange={handleSearchChange}
      />
    </SearchContainer>
  );
};

export default CourseFilter;
